<script setup lang="ts">import { createPropsRestProxy } from '/vue-macros/reactivity-transform/helper';
const content = createPropsRestProxy(__props, ["item","root"]);

import Tooltip from "@/components/Tooltip/Tooltip.vue";

import type { Evidence } from "@/models/Evidence";
import type { TooltipContentProps, TooltipRootProps } from "reka-ui";

withDefaults(defineProps<
  {
    root?: TooltipRootProps;
    item: Evidence & { displayValue: string | number; isAudio: boolean; pageHasAnnotations: boolean };
  } & TooltipContentProps
>(), {  })
</script>
<template>
  <Tooltip :content-props="content" :root-props="root">
    <template #trigger>
      <slot :disabled="root?.disabled" />
    </template>
    <template #content>
      Filename: {{ item.displayName }}
      <br />
      {{ `${item.isAudio ? "Time Range" : "Page Number"}: ` }} {{ item.displayValue }}
      <br />
      <template v-if="item.annotation">
        Label: {{ item.annotation }}
        <br />
      </template>
      <b v-if="item.pageHasAnnotations">This page contains annotations</b>
    </template>
  </Tooltip>
</template>
